import React, { useEffect } from "react";
import './styles.scss';
import DATA from 'utils/data.json';

const WHAT_DATA = DATA.what;

const What = () => {
    
    return (
        <section id='what-id' className="what-block container">
            <p className="title">{WHAT_DATA.title}</p>
            <div className="content content__1">
                <img src='/images/what-image-0.png' alt=''/>
                <ul>
                    <li><span dangerouslySetInnerHTML={{__html: WHAT_DATA.content[0]}}></span></li>
                    <li><span dangerouslySetInnerHTML={{__html: WHAT_DATA.content[1]}}></span></li>
                </ul>
            </div>
            <div className="content content__2">
                <img src='/images/what-image-1.png' alt=''/>
                <ul>
                    <li><span dangerouslySetInnerHTML={{__html: WHAT_DATA.content[2]}}></span></li>
                    <li><span dangerouslySetInnerHTML={{__html: WHAT_DATA.content[3]}}></span></li>
                    <li><span dangerouslySetInnerHTML={{__html: WHAT_DATA.content[4]}}></span></li>
                </ul>
            </div>
        </section>
    )
}

export default What